export default "__VITE_ASSET__DSeYtL0A__"